import { TranslationObject } from '../i18n/translation';

const translations: TranslationObject = {
  header: {
    id: 'selectrole.header',
    nb: 'Velg hvilken rolle du ønsker å logge på med',
    en: 'Select which role to log-in with',
  },
};

export default translations;
